"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgAntiCorrosiveFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.anti-corrosive_filled_svg__cls-1{display:none}')),
        React.createElement("g", { id: "anti-corrosive_filled_svg__transparent_box" },
            React.createElement("path", { className: "anti-corrosive_filled_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "anti-corrosive_filled_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "anti-corrosive_filled_svg__FILLED" },
            React.createElement("path", { d: "M5.99 28h20v2h-20zM16 14a4.46 4.46 0 004.46-4.46c0-3.45-3.6-7.09-3.75-7.25L16 1.57l-.71.74c-.38.4-3.73 4-3.73 7.23A4.46 4.46 0 0016 14zM22.97 19.43l.02 2.58 2-.02-.05-5.95L19 16l-.02 2 2.58.02-5.57 5.57-8.29-8.3-1.42 1.42 9.71 9.7 6.98-6.98z" }))));
}
exports.default = SvgAntiCorrosiveFilled;
//# sourceMappingURL=AntiCorrosiveFilled.js.map